/* eslint-disable react/prop-types */
import React from 'react';
import { Marker, Popup } from 'react-leaflet';
import { DivIcon, Icon, LatLngExpression } from 'leaflet';
import {
  CollectionIconMarker,
  IconMarkerGray,
  IconMarkerGreen,
  IconMarkerOrange,
  PaqueryPointIconMarker,
  TruckIconMarker,
} from './icons';
import { ActionStatus, GeolocationType, Waypoint } from 'interfaces/journey';
import { IconMarkerRed } from 'routes/app/legacyRoute/route/components/map/components/icons';
import { getWaypointIssue } from 'services/journeys/shipmentHelpers';
import { useJourneyDashboardContext } from '../../context';

interface WaypointMarkerProps {
  waypoint: Waypoint;
}

const getIconByOrder = (waypoint: Waypoint): Icon | DivIcon => {
  if (getWaypointIssue(waypoint)) return IconMarkerOrange;

  if (waypoint.actions?.some((action) => action.collectionId))
    return CollectionIconMarker;

  switch (waypoint.label) {
    case GeolocationType.DistributionCenter:
      return PaqueryPointIconMarker;
    case GeolocationType.DriverLocation:
      return TruckIconMarker;
    default:
      if (
        waypoint.actions?.find(
          (action) =>
            action.status === ActionStatus.Pending ||
            action.status === ActionStatus.Forced_end,
        )
      )
        return IconMarkerGray;
      else if (
        waypoint.actions?.find(
          (action) =>
            action.status === ActionStatus.Failed ||
            action.status === ActionStatus.Canceled,
        )
      )
        return IconMarkerRed;
      else return IconMarkerGreen;
  }
};

const WaypointMarker: React.FC<WaypointMarkerProps> = ({ waypoint }) => {
  const { shipmentsById } = useJourneyDashboardContext();
  const icon = getIconByOrder(waypoint);

  const position: LatLngExpression =
    waypoint.latitude && waypoint.longitude
      ? [waypoint.latitude, waypoint.longitude]
      : [0, 0];

  const externalCodes = Array.from(
    new Set(
      waypoint.actions
        ?.map(
          (action) =>
            action.routeShipmentId &&
            shipmentsById?.[action.routeShipmentId]?.externalCode,
        )
        .filter(Boolean),
    ),
  );

  return (
    <Marker
      key={Number.isNaN(waypoint.order) ? '-1' : waypoint.order}
      position={position}
      icon={icon}
    >
      {waypoint.address && (
        <Popup>
          <div>
            <h3>
              {waypoint.address}
              {waypoint.actions && waypoint.actions.length > 0
                ? ` (${waypoint.actions.length})`
                : ''}
            </h3>
            {externalCodes.length > 0 && (
              <ul style={{ margin: 0, paddingLeft: 16 }}>
                {externalCodes.map((code) => (
                  <li key={code}>{code}</li>
                ))}
              </ul>
            )}
          </div>
        </Popup>
      )}
    </Marker>
  );
};

export default WaypointMarker;
